import { render, staticRenderFns } from "./TwitchPostadmin.vue?vue&type=template&id=605ab762&scoped=true"
import script from "./TwitchPostadmin.vue?vue&type=script&lang=js"
export * from "./TwitchPostadmin.vue?vue&type=script&lang=js"
import style0 from "./TwitchPostadmin.vue?vue&type=style&index=0&id=605ab762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605ab762",
  null
  
)

export default component.exports